import { Right, Left } from "@insightfulscience/shared-utils/either";
import { mapGqlError } from "@insightfulscience/shared-utils/gqlClient/GqlError";
import routes from "../routes";

const expectedErrors = mapGqlError({
	INVOICE_QUOTE_FAILED: "errors.REQUEST_FAILED",
});

const onSuccess = routingService => () => routingService.push(routes.requestSponsorshipSuccess);

export const requestSponsorshipForm = request => ({ routingService, contactService }) => {
	return contactService
		.requestSponsorshipForm(request)
		.then(onSuccess(routingService))
		.then(Right)
		.catch(Left.from(expectedErrors));
};
